//Template.js
///////////////////////////////
//React & Material
import React from 'react';

//Plugins
import styled from 'styled-components';

//Component Imports
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import OkSvg from '../media/OK.svg';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { motion } from "framer-motion";
//////////////////////////////
//Styled components
const FullHeightContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top:50px;
  padding:20px;
  @media only screen and (min-width: 768px) {
    height:100vh;
  }
`
const HeadingRow = styled(Row)`
justify-content: flex-end;
`
const HeadingText = styled.p`
  font-family: Cardo;
  font-style: italic;
  font-weight: normal;
  font-size: 143px;
  line-height: 128.9%;
  /* or 184px */
  color: rgba(255, 255, 255, 0.22);
  text-align:right;
 
  @media only screen and (max-width: 767px) {
    font-size: 80px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 80px;
  }
`
const Content = styled.h2`

line-height: 159.4%;
/* or 57px */

text-align: right;

color: #FFFFFF;

@media only screen and (max-width: 767px) {
  font-size: 20px;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  font-size: 20px;
}
`
const CustomOk = styled.img`
  position:absolute;
  right:35%;
  margin-top:-20px;
`
const OkRow = styled(Row)`
  float:right;
  position:absolute;
  right:50vw;
  margin-top:-20px;

  @media only screen and (max-width: 767px) {
    margin-top:-2px;
  }
  
  @media only screen and (max-width: 767px) and (orientation: portrait) {
    margin-top:-2px;
  }
`
const Circle = styled.div`
  /* circle styles */
  width: 200px;
  height: 200px;
  border: 1px solid #222;
  border-radius: 50%;

  /* become a flex container */
  /* its children will be flex items */
  display: flex;
  /* place items in column */
  flex-direction: column;
  /* center flex items horizontally */
  align-items: center;
  /* center all content vertically */
  justify-content: center;

  background: #44FFC5;

  font-family: Cardo;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;

  @media only screen and (max-width: 767px) {
    width: 150px;
  height: 150px;
  font-size: 25px;
  }
  
  @media only screen and (max-width: 767px) and (orientation: portrait) {
    width: 150px;
  height: 150px;
  font-size: 25px;
  }
`

const DownLink = styled(AnchorLink)`
text-decoration: none;
color: inherit;
text-decoration: inherit;
-webkit-transition: color 1s ease-out;
 -moz-transition: color 1s ease-out;
 -o-transition: color 1s ease-out;
 -ms-transition: color 1s ease-out;
 transition: color 1s ease-out;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:black;
    }
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function AboutMe(props) {
  return (
    <FullHeightContainer id="about">
      <Container>
        {/* hi */}
        <HeadingRow>
          <HeadingText>
            So...
          </HeadingText>
        </HeadingRow>
        <HeadingRow>
          <Content>
          I firmly believe in usable, simple and feel-good interfaces <br />which gives a fascinating perspective into our lives...<br />moreover I give life to them.
            <br /><br />
            With a true passion on design and code, I enjoy <br />
            solving real-world problems and turning them into<br />
            beautiful, unique and delicate solutions which <br />
            would incite meaningful change.
            <br /><br />
            Currently at Sitemate, I am working on revolutionising <br />
             the ‘boring’ construction industry.
          </Content>
          </HeadingRow>
          <OkRow>
          <DownLink href='#thanks'>
          <Circle >
           <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2,
              loop: Infinity,
              ease: "linear",
            }}
            >  
             OK!
            </motion.div>
           </Circle>
           </DownLink>
          </OkRow>
          {/* <CustomOk src={OkSvg}/> */}
      </Container>
    </FullHeightContainer>
  )
}
export default AboutMe;
